import React, { Component } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PropTypes } from 'prop-types'
import Icon from 'antd/lib/icon'
import { Popover } from 'antd';
import addIcon from '~/assets/img/shift-to-open.svg';
import editIcon from '~/assets/img/edit-shift.svg';
class ResourceView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visiblePopoverFor: null, // stores slotId
        };
    }

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
        contentScrollbarHeight: PropTypes.number.isRequired,
        slotClickedFunc: PropTypes.func,
        slotItemTemplateResolver: PropTypes.func,
        toggleExpandFunc: PropTypes.func
    }

    showPopover = (slotId) => {
        this.setState({
            visiblePopoverFor: this.state.visiblePopoverFor === slotId ? null : slotId
        });
    };

    render() {

        const { schedulerData, contentScrollbarHeight, slotClickedFunc, slotItemTemplateResolver, toggleExpandFunc, singleResourceView, isTemplateView, t, userExceptionDetails, canCreateAndEdit } = this.props;
        const { renderData, resources } = schedulerData;
        let width = schedulerData.getResourceTableWidth() - 2;
        let displayRenderData = renderData.filter(o => o.render);
        let resourceList = displayRenderData.map((item, idx) => {
            let a = 
                <span>
                    <span className='truncate-2' style={{ fontSize: '11px', textDecoration: 'none', fontWeight: 'bold', color: item.slotPaymentMode === 'fixed' ? '#25ac3cff' : '#2550ac' }}>
                        {item.slotName}
                    </span>
                </span>;

            let threeDotsIcon = this.props.showResourcesThreeDots ?
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {canCreateAndEdit ? `${t('Add new')} | ${t('View')} ${t('Existing')}` : t("You don't have enough rights to perform this action")}
                        </Tooltip>
                    }
                >
                    <img src={addIcon} className={`me-2 ${canCreateAndEdit ? 'cursor-pointer' : 'cursor-no-drop'}`} onClick={() => this.props.handleResourceOptionClick(item.slotId, 'addNewTemplate')} />
                </OverlayTrigger>
                : <></>

            let slotItem = (
                <div title={item.slotName} className="overflow-text header2-text" style={{ textAlign: "left", paddingLeft: '15px', paddingRight: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ textAlign: 'left' }}>
                            <span>
                                {a}
                            </span>
                            {!isTemplateView && <div style={{ fontSize: '9px', fontWeight: 'bold' }}>
                                {`${item.slotEmployeePercent}% | ${(item.slotEmployeePercent * item.slotWorkTimeAgreement) / 100}  ${t('hr')}`}
                            </div>}
                        </div>
                        <span>
                            {userExceptionDetails && userExceptionDetails[item?.slotId] ?
                                <span className={'cursor-pointer text-danger'} title={t('Exception')} onClick={() => this.props.handleResourceOptionClick(item.slotId, 'navigateToException')}>
                                    <i class="fas fa-exclamation-triangle me-2 "></i>
                                </span>
                                :
                                <></>
                            }
                            {threeDotsIcon}
                        </span>
                    </div>
                </div>
            );

            if (!!slotItemTemplateResolver) {
                let temp = slotItemTemplateResolver(schedulerData, item, slotClickedFunc, width, "overflow-text header2-text");
                if (!!temp)
                    slotItem = temp;
            }

            let tdStyle = { height: item.rowHeight, paddingBottom: `${!singleResourceView && idx === displayRenderData.length - 1 ? '13px' : singleResourceView ? '40px' : 0}` };
            if (item.groupOnly) {
                tdStyle = {
                    ...tdStyle,
                    backgroundColor: schedulerData.config.groupOnlySlotColor
                };
            }

            return (
                <tr key={item.slotId}>
                    <td data-resource-id={item.slotId} style={tdStyle}>
                        {slotItem}
                    </td>
                </tr>
            );
        });

        return (
            <div>
                <table className="resource-table">
                    <tbody>
                        {resourceList}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default ResourceView